import React from 'react';

const TermsAdditionalFr = () => (
  <div>
    <p>
      <strong>
        MYSKP CONDITIONS D’UTILISATION ADDITIONNELLES ET SUPPLÉMENT VIE PRIVÉE
      </strong>
    </p>
    <p>Dernière mise à jour : 22 Juillet 2019</p>
    <p>
      Votre utilisation de la plateforme MYSKP / MYTRACKER et du site Web de
      Henkel Canada Corporation ou de l’une de ses filiales ou sociétés
      affiliées (collectivement appelés “SKP”, “nous”, “notre” ou “nos”) à
      http://myskp.com/ca et à la suite d’applications commerciales de MYSKP
      (appelée collectivement dans les présentes <strong>“MYSKP”</strong>) est
      assujettie à nos{' '}
      <a
        href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Conditions d’utilisation et à notre Déclaration de confidentialité
      </a>
      , ainsi qu’au présent Supplément aux Conditions d’utilisation et à la
      confidentialité (les “<strong>Conditions supplémentaires</strong>”).
    </p>
    <p>
      En installant, téléchargeant ou utilisant autrement MYSKP, vous êtes
      réputé avoir lu et accepté d’être lié par nos Conditions d’utilisation et
      par les présentes Conditions supplémentaires et accepter notre{' '}
      <a
        href="https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Déclaration de confidentialité
      </a>
      . Si vous ne consentez pas à tout ce qui précède, vous ne devriez pas
      utiliser MYSKP.
    </p>

    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Fonctions de MYSKP</strong>
        </p>
        <p>
          MYSKP est une suite d’applications et un site web pour utilisation par
          des stylistes professionnels, salons, distributeurs et représentants
          des distributeurs au Canada. Il sert d’outil de vente et de marketing
          en aidant à faciliter la gestion de l’inventaire (sur une base de
          produits vendus), le placement de commandes de restockage et les
          ventes, en permettant aux stylistes et aux salons de suivre
          l’historique de leur inventaire, leurs achats et leur utilisation, et
          peut aussi contribuer à améliorer le branding créatif de SKP au niveau
          du salon. Il permet à SKP, aux distributeurs et aux représentants du
          distributeur de reviser les ventes, les informations sur le salon et
          les produits au sein de leur chaîne d’approvisionnement pour des
          motifs incluant la gestion de leur salon et les outils pour analyser
          les données de performance et aider à maximiser les ventes avec des
          unités de mesure visuelles sur leurs données de rendement du salon. Il
          assiste aussi SKP sur la gestion de programmes incitatifs de gestion
          et de ventes des distributeurs.
        </p>
        <p>
          La suite d’applications de MYSKP offre, ou pourrait offrir dans le
          futur, les caractéristiques suivantes:
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>
              <strong>CLUBSKP</strong>
            </p>
            <p>
              Un module qui permet aux utilisateurs éligibles d’accéder à leur
              compte CLUBSKP- un programme de fidélisation permettant aux salons
              d’échanger et de faire le suivi des points déterminés par les
              données de vente, en conformité avec les Conditions du programme
              CLUBSKP. Ce module est organisé comme un système d’e-commerce à
              travers lequel les points peuvent être échangés aux taux
              déterminés par SKP occasionnellement, et sujets aux Conditions du
              Programme CLUBSKP.
            </p>
            <p>
              <strong>CENTRE D’IMPRESSION</strong>
            </p>
            <p>
              Un module où les salons peuvent personnaliser du matériel et
              commander du Matériel Promotionnel, incluant des accessoires
              imprimés de la marque, tels que décrits plus avant dans la section
              3 ci-dessous. Les utilisateurs peuvent soit commander en ligne
              directement avec un fournisseur tiers pour la réalisation ou
              télécharger le matériel directement pour leur utilisation
              personelle en conformité avec ces Conditions Additionnelles et
              toute autre condition spécifiée, limites d’utilisation ou
              instructions pouvant être fournies par SKP. Si vous choisissez de
              commander en ligne avec un fournisseur tiers, vous devrez accepter
              les conditions d’utilisation de ce tiers. Une telle commande en
              ligne constitue un Service par un Tiers selon la signification de
              nos Conditions d’Utilisation. Vous comprenez et acceptez que nous
              n’assumons aucune responsabilité face au Service d’un Tiers. De
              plus, alors que nous pourrions vous fournir un lien vers le site
              web d’un tiers, il est compris que nous n’endossons, n’approuvons,
              commanditons ou supportons ces sites ou services.
            </p>
            <p>
              <strong>FILEVAULT</strong>
            </p>
            <p>
              Un dépôt en ligne et partage de fichiers d’actifs de marque
              incluant des images, du matériel marketing et des vidéos tel que
              déterminé par SKP occasionnellement. SKP peut fixer des limites
              sur ce que les utilisateurs peuvent avoir accès. Sujet à ces
              limites, tous les actifs sont organisés dans des fichiers avec la
              possibilité pour les utilisateurs de créer les leurs. Certains
              actifs peuvent être téléchargés directement dans différentes
              tailles de fichier ou raisons d’une application. Tout le matériel
              dans le fichier voute est du ‘’Matériel Publicitaire’’ selon la
              définition de la section 3 ci-dessous, et ne peut être utilisé
              qu’en conformité avec ces Conditions d’Utilisation, et toute autre
              condition spécifiée, limites d’utilisation ou instructions pouvant
              être fournis par SKP.
            </p>
            <p>
              <strong>POE</strong>
            </p>
            <p>
              C’est un module utilisé par SKP pour administrer le programme
              Incitaif de Ventes du distributeur appelé “Profil d’Excellence”,
              utilisant l’information téléversée par les distributeurs utilisant
              l’outil ETL. SKP utilise un outil ETL pour extraire toutes les
              données de vente à partir du système ERP de Schwarzkopf et/ou des
              données du Distributeur. Par la suite, le module alloue
              automatiquement des points et les primes dues au consultant en
              salon, s’il y a lieu et génère des factures. Tous les participants
              peuvent suivre leur progrès ainsi que vérifier le classement au
              tableau des meneurs. SKP ne garantit pas l’exactitude du tableau
              des meneurs, ou tout total de points, et peut les ajuster
              occasionnellement si une erreur est trouvée.
            </p>
            <p>
              <strong>ADVISORNET</strong>
            </p>
            <p>
              C’est un module de suivi quotidien et planificateur d’évènement
              pour la formation ou pour les membres de l’équipe d’aviseurs
              techniques internes et superviseurs techniques. Ces utilisateurs
              peuvent se servir du module pour planifier, faire le suivi et
              produire un rapport de leurs activités quotidiennes. Il fait le
              suivi des activités à l’agenda des aviseurs techniques SKP et sert
              de site de remboursement pour les coûts associés au travail de ces
              aviseurs techniques en fonction d’un processus d’autorisation
              incorporé par SKP permettant un déploiement automatique de
              factures pour le remboursement des dépenses, permettant à SKP de
              faire le suivi et de rembourser les tiers désignés par SKP, de la
              manière et selon les montants ayant été approuvés par SKP. Les
              rapports de performance détaillés aident tous les intervenants à
              gérer et améliorer l’efficacité e leurs activités quotidiennes.
            </p>
            <p>
              <strong>MYTRACKER</strong>
            </p>
            <p>
              Permet un suivi visuel par SKP de toutes les données contenues
              dans MYSKP, ce qui inclut tant les données de vente et d’activité.
              Les distributeurs ne peuvent consulter que leurs propres données
              et celles des activités de leurs consultants en salon.
            </p>
          </li>
        </ul>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Accès à MYSKP et sécurité des comptes</strong>
        </p>
        <p>Vous êtes responsable de ce qui suit:</p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              · Faire tous les arrangements nécessaires pour vous permettre
              d’avoir accès à MYSKP; et
            </p>
          </li>
          <li>
            <p>
              De vous assurer que toutes les personnes qui accèdent à MYSKP via
              votre connection internet sont conscientes de ces Conditions
              d’Utilisation et s’y conforment.
            </p>
          </li>
        </ul>
        <p>
          Pour accéder à MYSKP ou à certaines ressources qu’il offre, vous
          pourriez devoir fournir certains détails d’inscription ou autres
          informations. C’est une condition d’utilistion de MYSKP que toute
          l’information fournie à MYSKP est correcte, actuelle et complète.
        </p>
        <p>
          Pour accéder aux services de MYSKP vous devrez vous inscrire sur
          MYSKP. Toutes les inscriptions sont sujettes à l’acceptation par SKP,
          et pourraient être retenues ou refusées à notre seule et absolue
          discrétion. SKP peut à sa discrétion établir (ou réétablir) différents
          niveaux d’accès à MYSKP pour différents utilisateurs et/ou comptes, ce
          qui pourrait modifier le contenu, les applications, les
          caractéristiques ou fonctions que ces utilisateurs et /ou comptes
          pourraient accéder sur MYSKP. Vous acceptez de: (a) maintenir la
          confidientalité de tout mot de passe ou autre identifiant du compte,
          que vous avez choisi ou qui vous ont été assignés à la suite de toute
          inscription ou création de compte avec MYSKP; et (b) être responsable
          de toutes les activités qui se déroulent sous ce mot de passe ou
          compte. De plus, vous acceptez de nous aviser immédiatement de toute
          utilisation non-autorisée de votre mot de passe ou compte dans
          l’éventualité où la confidentialité de votre mot de passe ou de votre
          compte est compromise. Le défaut de se conformer à ce paragraphe
          pourrait entraîner la fermeture immédiate de votre compte. Nous ne
          devons pas être tenu responsables directement ou indirectement, de
          quelque manière que ce soit pour toute perte ou dommage de toute sorte
          subi résultant de , ou en lien avec, votre défaut de vous conformer à
          cette section, ou pour tout délai dans la fermeture de vore compte
          après que vous nous ayez rapporté une faille de sécurité. Vous
          acceptez aussi de vous assurer de sortir de votre compte à la fin de
          chaque session. Vous devriez apporter une prudence particulière
          lorsque vous accédez à votre compte via un ordinateur public ou
          partagé afin que les autres ne puissent voir ou enregistrer votre mot
          de passe ou autres informations personnelles ou d’affaires.
        </p>
        <p>
          Nous avons le droit de désactiver votre compte et/ou tout nom
          d’utilisateur, mot de passe ou autre identifiant, qu’il soit choisi
          par vous ou fourni par nous, à tout moment, à notre seule discrétion
          incluant si, à notre opinion, vous avez violé tout élément de de ces
          Conditions Additionnelles, tout autre entente convenue avec nous, ou
          nous avons un motif raisonnable de croire que votre compte a été
          compromis. À l’occasion, nous pourrions restreindre l’accès à
          certaines parties de MYSKP, ou à l’ensemble de MYSKP. Ces restrictions
          pourront s’appliquer à des comptes individuels MYSKP, à tous les
          comptes ou à tout sous-ensemble de ceux-ci.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Licence relative à du matériel publicitaire précis</strong>
        </p>
        <p>
          Nous vous accordons un droit et une licence limitée, non-exclusive,
          personnelle, non-transférable, non-sous-licensable et révocable
          d’accéder voir et imprimer toute information et documentation rendus
          disponibles sur MYSKP, pour votre utilisation personnelle,
          non-commerciale (autre que si permis en conformité avec ces Conditions
          d’Utilisation), et informative seulement pour vous assister dans
          l’accès et l’utilisation de MYSKP. Certaines caractéristiques de MYSKP
          peuvent vous permettre de télécharger des pages d’annonces
          publicitaires prêtes à utiliser et du matériel pour la promotion de la
          disponibilité de produits SKP dans votre entreprise (“
          <strong>Matériel publicitaire</strong>”). Nous vous accordons un droit
          et une licence limité, non-exclusif, personnel, non-transférable, non
          sous-licensable et révocable d’accéder, de voir, d’imprimer et de
          diffuser, à l’intérieur du Canada seulement, le Matériel Publicitaire
          rendu disponible sur MYSKP, dans le seul objectif de promouvoir la
          disponibilité de produits SKP dans votre entreprise. Tout utilisation
          de Matériel Publicitaire doit: i) être pour la promotion des ventes de
          produits SKP; ii) être faite de manière qui n’affecte ou ne dénigre
          pas tout logo ou marque de commerce SKP; iii) être faite afin de ne
          pas crcéer de la confusion dans le public; iv) se confirmer avec toute
          condition spécifiée, limites d’utilisation ou instructions pouvant
          être fournis par SKP. Cette licence inclut la possibilité limitée de
          modifier le Matériel Publicitaire pour y inclure des informations
          concernant votre entreprise ainsi que toute offre ou promotion que
          vous choisissez de faire en fonction de celle-ci (“
          <strong>Offres</strong>”), mais non d’altérer ou de modifier tout logo
          SKP, marque de commerce, graphique ou image qui doivent apparaître
          seulement tels que fournis dans le Matériel Publicitaire. Vous, et non
          SKP, êtes responsable pour toute Offre que vous choisissez de faire,
          et, sans limitation êtes responsable d’assurer leur conformité légale.
        </p>
        <p>
          Certain Matériel Publicitaire ou autre matériel disponible sur MYSKP
          peut être sujet à des conditions d’utilisation additionnelles,
          instructions, restrictions, ou limitations qui diffèrent de la licence
          ci-dessus. Par exemple, cela peut inclure des limitations
          territoriales additionnelles et/ou des périodes d’utilisation
          restreintes. Si vous choisissez d’utiliser tout Matériel Publicitaire
          ou autre matériel disponible sur MYSKP, vous devez accepter de et vous
          conformer avec toute condition, instruction, restriction, ou
          limitation. Vous acceptez de devoir cesser l’utilisation de tout
          Matériel Publicitaire ou autre
        </p>
        <p>
          À l’exception des droits et licenses qui vous sont expressément
          accordés dans les Conditions d’Utilisation, ces Conditions
          d’Utilisation ne vous accordent aucun autre droit ou licence sur ou en
          lien avec tout brevet, marque de commerce, droit d’auteur, ou autre
          propriété intellectuelle ou droit de propriété. Nous pouvons mettre
          fin à cette license ou la suspendre à tout moment, pour toute raison,
          à notre seule et absolue discrétion. Tout utilisation pouvant suggéré
          une communauté d’intérêts, ou une relation d’affaire est aussi
          strictement défendue.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Achats à l’aide de MYSKP</strong>
        </p>
        <p>
          Certaines caractéristiques de MYSKP peuvent maintenant ou pourront
          dans le futur vous permettre de faire des achats. Vous pouvez
          seulement faire des achats sur MYSKP si vous avez atteint l’âge légal
          de la majorité dans votre juridiction de résidence. Les achats ne
          seront expédiés qu’à une addresse postale valide au Canada (tel que
          déterminé par SKP à sa seule et absolue discrétion). Toutefois,
          veuillez noter que nous pourrions ne pas pouvoir expédier à certaines
          adresses postales valides et, dans ces circonstances, nous nous
          réservons le droit, à notre seule et absolue discrétion, d’annuler
          votre achat (“<strong>Commande</strong>”). Dans l’éventualité où nous
          sommes incapables d’expédier à l’adresse d’expédition fournie, nous
          vous en aviserons, votre Commande sera annulée, et vous recevrez un
          remboursement au montant de votre Commande (à moins que vous ne
          puissiez nous fournir une adresse de livraison alternative éligible).
          Nous nous réservons de plus le droit de ne pas offrir certaines formes
          d’expédition. Sauf si spécifié autrement, tous les montants indiqués
          sont enDollars Canadiens.
        </p>
        <p>
          Toutes les commandes effectuées via MYSKP sont sujettes à ces
          Conditions Additionnelles, ainsi qu’à tout autre terme et condition
          applicables définis sur MYSKP en lien avec les Commandes. Le prix et
          autres et conditions en lien avec l’achat, le retour, le remboursement
          ou la livraison de votre Commande peuvent être modifiés à tout moment
          sans avis. Les prix peuvent différer des prix affichés si les achats
          sont faits via d’autres canaux. Vous avez l’obligation légale de payer
          pour toute Commande indiquée comme ayant été effectuée par vous. En
          complétant une Commande sur MYSKP, vous acceptez de payer, en entier,
          le prix et les taxes applicables et les frais spécifiés d’expédition
          et de manuntention liés à votre Commande, soit par carte de crédit ou
          autre méhode de paiement autorisée.
        </p>
        <p>
          SKP se réserve le droit, à sa seule et absolue discrétion, de changer
          les méthodes de paiement permises, incluant, sans limitation, par
          cartes de crédit et/$ ou types de paiement que nous pouvons accepter à
          tout moment. Si le paiement complet pour votre Commande n’est pas reçu
          et vérifié par nous, votre Commande ne sera pas complétée. Si vous ne
          complétez pas ou complétez incorrectement votre Commande, elle
          pourrait ne pas être acceptée ou confirmée.
        </p>

        <p>
          Afin de compléter une Commande via MYSKP, vous pourriez devoir fournir
          des informations additionnelles requises pour traiter votre Commande.
          Par exemple, vous devrez fournir des informations pour paiment valides
          (ex. Un numéro de carte de crédit valide et une date d’échéance) pour
          faciliter le paiement de votre Commande.
        </p>
        <p>
          Vous serez facturé pour votre Commande au moment où la Commande est
          placée. Vous serez responsable de toutes les taxes applicables en lien
          avec votre Commande. Les taxes applicables seront facturées au moment
          de la facturation. Les taxes de vente applicables seront aussi
          appliquées à la manutention et l’expédition, les frais de retour les
          emballages cadeau ou autres frais. Les taxes peuvent dépendre du lieu
          de livraison.
        </p>
        <p>
          Sans limiter la généralité de toute autre section de ces Conditions
          Additionnelles, SKP se réserve le droit de limiter ou refuser toute
          Commande placée par vous. De plus, nous nous réservons le droit de
          vérifier la validité de toute Commande et/ou d’annuler toute Commande
          si nous trouvons des preuves de fraude, falsification et/ou toute
          autre violation des termes et conditions de ces Conditions
          Additionnelles, ou de nos Conditions d’Utilisation. Nous pourrions, à
          notre seule et absolue discrétion, limiter ou annuler les quantités
          achetées par personne, par compte ou par Commande. Ces restrictions
          pourraient inclure des Commandes placées par ou via le même compte,
          par le même salon ou la même entreprise, utilisant la même carte de
          crédit, et/ou les Commandes utilisant la même adresse de facturation
          et de livraison. Nous nous réservons aussi le droit, à notre seule et
          absolue discrétion, de ne pas expédier des items commandés ou achetés
          via MYSKP à certaines adresses. Dans l’éventualité où nous ne
          pourrions choisir d’expédier un item, vous en serez avisé et le
          montant pour cet item facturé sur votre Commande sera réduit en
          conséquence.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Communications sur MYSKP</strong>
        </p>
        <p>
          MYSKP permet à SKP de faire parvenir des communications et
          notifications aux utilisateurs, et/ou à toute classe particulière
          d’usagers tant via le portail en ligne de MYSKP et/ou via des
          notifications par courriel. Certaines caractéristiques de MYSKP
          peuvent permettre à certaines classes d’utilisateurs de communiquer
          avec d’aures utilisateurs – tant via le module en ligne de MYSKP et/ou
          via des notifications par courriel. Si nous vous autorisons à
          communiquer et que vous choisissez de communiquer avec d’autre
          utilisateurs, vous devrez vous conformer avec toutes les lois
          applicables se faisant, incluant, sans limitation, toutes les lois
          Canadiennes sur la vie privée, et la législation anti-pourriels du
          Canada. Vous devez avoir les consentements requis sous ces lois, et
          devez inclure dans vos messages toutes les déclarations obligatoires
          de contenu, incluant, sans limitation, tous les mécanismes requis pour
          se désabonner.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Indemnisation</strong>
        </p>
        <p>
          Vous acceptez de défendre, d’indemniser et de tenir non-responable
          SKP, et nos affiliés, et les officiers, directeurs, employés, agents
          et représentants de chacun de ceux-ci, de et contre toute requête,
          action, demande, perte, responsabilité, dommage, coût, poursuite,
          action, pénalité et dépense, survenant de ou en lien, directement ou
          indirectement à: (i) votre accès à et/ou utilisation d’un service
          MYSKP, et/ou toute composante de celui-ci, (ii) votre violation de ces
          termes et conditions, de cette entente; (iii) votre utilisation du
          Matériel Publicitaire, incluant toute Offre que vous choisissez de
          promouvoir en association avec cela, et/ou (iv) la violation de droits
          par vous de tout tiers utilisant votre compte, de toute propriété
          intellectuelle ou tout autre droit de toute autre personne ou entité
          incluant, sans limitation, si vous enfreignez les termes de toute
          licence associée avec le Matériel Publicitaire. Vous acceptez que SKP
          puisse assumer le contrôle et la défense exclusive de toute matière
          pour laquelle vous devez indemniser SKP et vous acceptez de coopérer,
          à vos frais, à notre défense de ces requêtes. Vous acceptez de ne pas
          régler aucune de ces questions sans le consentement écrit de SKP.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Avis électroniques</strong>
        </p>
        <p>
          Dans l’éventualité où nous vous contactons, vous acceptez que nous
          pourrions le faire via un moyen électronique, incluant mais ne se
          limitant pas à des communications affichées sur MYSKP, notifications
          sur l’application Messenger ou courrier électronique.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Absence de relation de mandataire</strong>
        </p>
        <p>
          Vous acceptez qu’il n’existe aucun joint-venture, partenariat relation
          de pouvoir ou d’emploi entre vous et SKP résultant de ces Conditions
          d’Utilisation ou l’utilisation de MYSKP et l’accès à ses services.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Cessation</strong>
        </p>
        <p>
          Si vous transgressez toute clause de ces Conditions Additionnelles
          (tel que déterminé par SKP à sa seule et absolue discrétion), alors
          vous ne pourrez plus utiliser MYSKP, les services, ou toute composante
          de ceux-ci. Nous pourrions, à notre seule et absolue discrétion,
          changer, suspendre ou mettre fin, temporairement ou définitivement à
          MYSKP, les services, ou toute composante de ceux-ci ou toute
          caractéristique de ceux-ci à tout moment, pour toute raison, sans avis
          ou responsabilité envers vous ou toute autre entité. Si nous mettons
          fin à ces Conditions d’Utilisation ou à votre permission d’utiliser
          MYSKP pour toute raison, l’accord formé par l’acceptation de ces
          Conditions d’Utilisation va néanmoins continuer à s’appliquer et vous
          y serez lié dans la mesure de votre utilisation préalable de MYSKP,
          des services, ou toute composante de ceux-ci, puis votre seul recours
          sera de cesser de les utiliser.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Collecte, utilisation et divulgation de renseignements par MYSKP.
          </strong>
        </p>
        <p>
          Suivant les termes de notre{' '}
          <a
            href="https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Déclaration de confidentialité
          </a>
          , qui s’appliquent à MYSKP en plus de cette section, lorsque vous
          utilisez MYSKP, vous acceptez que nous pourrions recueillir, utiliser,
          et révéler vos informations tel que décrit dans cette section.
        </p>
        <p>
          Si vous fournissez des informations pertinentes à un tiers, telles
          q’un de vos distributeurs ou une personne dans un salon, vous
          représentez et nous mandatez que vous avez le consentement de cette
          partie à la collecte, l’utilisation et le partage de l’information
          dans cette section et notre Déclaration de Vie Privée, et que vous
          avez le droit de révéler et permettez à Henkel d’utiliser et de
          révéler cette dite information des objectifs visés dans cette section
          et notre Déclaration de Vie Privée et vous avez obtenu tous les
          consentements applicables ou autorisations nécessaires à ceux-ci, si
          requis. Si nous déterminons que vous avez déroger à cette clause, nous
          nous réservons le droit de limiter ou de terminer votre accès à MYSKP
          comme nous le jugerons approprié, à notre seule et absolue discrétion.
        </p>
      </li>
    </ol>
    <ol type="A" style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Collecte d’Information sur MYKP.</strong> SKP collecte les
          informations identifiables suivantes via MYSKP:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>Vos noms et prénoms;</p>
          </li>
          <li>
            <p>L’Identifiant de votre Consultant en Salon (si applicable);</p>
          </li>
          <li>
            <p>
              L’Adresse Courriel de votre Consultant en Salon (si applicable);
            </p>
          </li>
          <li>
            <p>Le nom du salon et de son propriétaire;</p>
          </li>
          <li>
            <p>
              Toute information de contact fournie par vous incluant, mais ne se
              limitant pas à votre numéro de téléphone et adresse;
            </p>
          </li>
          <li>
            <p>
              Votre adresse courriel ainsi que toute information de contact
              fournie au moment de l’inscription pour un compte sur MYSKP;
            </p>
          </li>
          <li>
            <p>
              Des données de géo-localisation, si ces données peuvent permettre
              votre identification; et
            </p>
          </li>
          <li>
            <p>
              Toute autre information personnelle identifiable que vous
              choisissez de nous fournir en utilisant MYSKP
            </p>
          </li>
        </ul>
        <p>
          Pour les utilisateurs qui sont des distributeurs, MYSKP collecte les
          informations que vous nous fournissez come suit:
        </p>
        <p>
          <strong>Tableau des Ventes</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- Identifiant de la transaction</p>
          </li>
          <li>
            <p>- Date de la transaction</p>
          </li>
          <li>
            <p>- Numéro de taxes du salon OU Identifiant du salon</p>
          </li>
          <li>
            <p>- Identifiant du représentant des ventes</p>
          </li>
          <li>
            <p>- Numéro d’article/de produit</p>
          </li>
          <li>
            <p>- Nom du produit</p>
          </li>
          <li>
            <p>- Qté</p>
          </li>
          <li>
            <p>- Coût total</p>
          </li>
          <li>
            <p>
              *S’il n’y a pas d’Identifiant unique pour les Consultants en
              Salon, veuillez inclure l’adresse courriel du Consultant dans le
              champs Identifiant du Consultant en Salon
            </p>
          </li>
        </ul>
        <br />
        <p>
          <strong>Tableau des Produit</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- Numéro d’article/de produit</p>
          </li>
          <li>
            <p>- Henkel IDH#</p>
          </li>
          <li>
            <p>- Gamme de produit</p>
          </li>
          <li>
            <p>- Nom du Produit</p>
          </li>
          <li>
            <p>- Description du Produit</p>
          </li>
          <li>
            <p>- Catégorie du Produit</p>
          </li>
          <li>
            <p>- Sous-Catégorie du Produit</p>
          </li>
          <li>
            <p>- Prix du Produit</p>
          </li>
        </ul>
        <br />
        <p>
          <strong>Tableau Salon</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- Identifiant Salon</p>
          </li>
          <li>
            <p>- Nom du Salon</p>
          </li>
          <li>
            <p>- Contact Salon</p>
          </li>
          <li>
            <p>- Adresse Courriel du Salon</p>
          </li>
          <li>
            <p>- Adresse Civique du Salon1</p>
          </li>
          <li>
            <p>- Adresse Civique du Salon 2</p>
          </li>
          <li>
            <p>- Adresse Salon Ville</p>
          </li>
          <li>
            <p>- Adresse Salon Code Postal</p>
          </li>
          <li>
            <p>- Adresse Salon Province</p>
          </li>
          <li>
            <p>- Adresse Salon Pays</p>
          </li>
          <li>
            <p>- Région Salon</p>
          </li>
          <li>
            <p>- Sous-Région Salon</p>
          </li>
        </ul>
        <br />
        <p>
          <strong>Tableau Consultants en Salon</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- Identifiant Consultant</p>
          </li>
          <li>
            <p>- Nom du Consultant</p>
          </li>
          <li>
            <p>- Adresse Courriel du Consultant</p>
          </li>
          <li>
            <p>- Région du Consultant</p>
          </li>
          <li>
            <p>- Sous-Région du Consultant</p>
          </li>
        </ul>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Utilisation de l’Information par MYSKP</strong>
        </p>
        <p>
          Les informations personnelles et toute autre information obtenue de
          vous par l’utilisation de MYSKP peut être utilisée par SKP et ses
          fournisseurs de services pour des fins d’analyse, incluant l’examen et
          l’évaluation de votre utilisation de MYSKP (incluant les modules et
          applications de MYSKP que vous utilisez et à quelle fréquence et
          pendant combien de temps vous les utilisez et cliquez sur le flux) et
          pour des motifs d’évaluation d’affaires et des performances futures
          incluant la prévision et la modélisation. En plus de ce qui précède,
          SKP pourrait utiliser ces informations s’il le juge raisonnablement
          nécessaire pour les motifs suivants:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>Gérer votre compte sur MYSKP;</p>
          </li>
          <li>
            <p>
              Vous procurer les services et caractéristiques disponibles sur
              MYSKP incluant produire et préparer des rapports sur vos ventes,
              niveaux de produits et historique d’achat, et ceux du salon dans
              votre chaîne d’approvisionnement;
            </p>
          </li>
          <li>
            <p>
              Faciliter tout achat que vous décider d’effectuer utilisant un
              site web, incluant faciliter le paiement de vos achats;
            </p>
          </li>
          <li>
            <p>
              Vous aviser lorsqu’une commande que vous avez placé utilisant un
              site web est prête pour la cueillette ou la livraison;
            </p>
          </li>
          <li>
            <p>
              Pour gérer tout programme de fidélisation, de récompenses ou
              d’incitatifs, nous pourrions offrir et choisir de vous donner un
              accès via MYSKP, incluant vous permettre de réviser votre solde,
              les échanges de points et toutes les récompenses reçues en
              conformité avec les conditions desdits programmes;
            </p>
          </li>
          <li>
            <p>
              Pour créer une liste accessible au public de Salons et autres
              places d’affaire qui revendent les produits SKP, incluant le nom
              de l’entreprise et les informations de contact;
            </p>
          </li>
          <li>
            <p>
              Pour vous permettre de créer un calendrier de vos évènements
              planifiés, rendez-vous et activités; et
            </p>
          </li>
          <li>
            <p>
              Si vous choisissez de fournir vos informations de localisation,
              pour vous permettre d’établir des cartes et itinéraires pour vos
              activités planifiées, telles que des visites planifiées aux salons
            </p>
          </li>
        </ul>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Divulgation d’Informations par MYSKP</strong>
        </p>
        <p>
          Veuillez noter que SKP se réserve le droit de divulguer vos
          informations personnelles, si cela est raisonnablement nécessaire, à
          un tiers sans votre consentement préalable dans les circonstances
          suivantes:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              Si votre conduite sur MYSKP transgresse les Conditions
              d’Utilisation et la divulgation de telles informations pourrait
              permettre à SKP de protéger ses droits légitimes et/ou lui
              permettre d’avoir accès à tout recours qui pourrait leur être
              disponible légalement;
            </p>
          </li>
          <li>
            <p>
              Si SKP juge en toute bonne foi, que cette divulgation est
              nécessaire pour identifier et/ou contacter toute personne afin de
              ou instituer des actions judiciaires contre une personne pour
              protéger ou faire valoir les droits de propriété de SKP ou ceux
              d’autres utilisateurs; ou
            </p>
          </li>
        </ul>
        <p>
          Si SKP considère de bonne foi que la loi exige ou permet ladite
          divulgation, y compris le partage de renseignements personnels
          permettant de vous identifier avec d’autres entreprises et
          organisations pour la prévention de la fraude, ou pour respecter toute
          exigence juridique ou réglementaire.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Données Techniques</strong>
        </p>
        <p>
          Vous acceptez que SKP <strong>et</strong>/ou ses fournisseurs de
          services puissent colliger et utiliser des données techniques et
          informations liées, incluant mais ne se limitant pas à des
          informations techniques à propos de votre système, et votre logiciel
          d’application, et les périphériques pour faciliter la production de
          mises à jour logicielles, de soutien du produit et autres services
          pour vous (si requis) en lien avec MYSKP. SKP ou Zapplogix pourront
          utiliser et divulguer <strong>cette</strong> information à des tiers,
          aussi longtemps qu’elle n’est pas dans une forme qui permette de vous
          identifier personnellement, pour améliorer ses produits ou vous
          procurer des services ou technologies
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Cookies</strong>
        </p>
        <p>
          Nous pourrions utiliser une caractéristique sur votre système ou
          navigateur appelé un "cookie" et/ou autre dispositif similaire. Les
          cookies sont de petits fichiers que votre navigateur place sur le
          disque dur de votre appareil. Ils sont utilisés pour une variété de
          raisons, telles que monitorer les cliques sur le flux de navigation,
          l’optimisation, le marketing et l’équilibrage de la charge. Nous
          utilisons une combinaison de sessions et des cookies persistents pour
          activer nos fonctions de connection, panier de magasinage, rappeler
          des items que vous avez ajouté à votre panier. Vous permettrre de
          créer des listes de souhaits, le processus de fermeture de session et
          pour procurer l’utilisation avec la possibilité de se rappeler et
          d’améliorer votre expérience. Nous pourrions utiliser cette
          information pour déterminer votre localisation géographique générale
          pour afficher la bonne version de MYSKP. Les informations suivies par
          ces mécanismes peuvent inclure, mais ne se limitent pas à : (i) votre
          adresse IP; (ii) le type de navigateur et de système d’opération
          utilisé; et (iii) les pages du site ou de l’application qu’un
          utilisateur visite. Votre navigateur vous donne l’option de rejetter
          les cookies. Toutefois, régler votre navigateur pour rejetter les
          cookies affecte généralement la performance du navigateur et va donc
          affecter également votre expérience d’utilisation de MYSKP, et
          certaines caractéristiques pourraient ne pas fonctionner. Pour pouvoir
          effectuer un achat sur MYSKP, les cookies suivants sont nécessaires et
          devront être acceptés: ‘siteId’, ‘id_token.*’, ‘gId’, ‘locale’.
        </p>
      </li>
    </ol>
  </div>
);

export default TermsAdditionalFr;



// WEBPACK FOOTER //
// ./src/components/_Site/CA/TermsAdditionalFr.js